import { Outlet } from 'react-router-dom'
import { useAdminPermissions } from '../contexts/AdminPermissionsContext'

// Guard de permiso explícito. No redirige (evita loops): muestra el mensaje en el
// área de contenido. La autorización real ocurre en la Edge Function.
export default function PermissionRoute({ permiso }) {
  const permissions = useAdminPermissions()
  if (permissions.loading) return <div className="py-16 text-center text-sm text-text-secondary" role="status">Verificando permisos…</div>
  const allowed = permiso === 'gestionar_usuarios' && permissions.puedeGestionarUsuarios
  if (!allowed) {
    return <div className="mx-auto max-w-xl rounded-2xl border border-danger/25 bg-danger/5 p-6 text-center text-danger" role="alert">No tienes permisos para acceder a esta sección.</div>
  }
  return <Outlet />
}
